import {CONTEXT_INITIAL_STATE} from "../constants"

export default function logout(context){


    const contextState = context.state || context

    context.set({
        ...CONTEXT_INITIAL_STATE,
        isTeacher:null ,
        person: null,
        credentials: contextState.credentials,
        systemParams: contextState.systemParams,
        systemConfig: contextState.systemConfig,
        systemConfigParameterValue: contextState.systemConfigParameterValue,
        publicArea: contextState.publicArea,
        sections: contextState.sections,
        banners: contextState.banners,
        sectionsData: contextState.sectionsData,
        cacheEadAccountList: null ,
    })

}


// WEBPACK FOOTER //
// ./src/_functions/logout.js